import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { Button } from 'app/agriculture/components/Button/Button';

export function EntityDiscardChangedDialog({
    isOpen,
    onResolve,
    onReject,
}: {
    isOpen: boolean;
    onResolve: () => void;
    onReject: () => void;
}) {
    return (
        <Dialog
            open={isOpen}
            sx={{
                '.MuiPaper-root': {
                    padding: '24px',
                    borderRadius: '16px',
                },
            }}
        >
            <DialogTitle
                style={{
                    padding: '0',
                    marginBottom: '24px',
                }}
            >
                <h5 id="discard-changes-dialog-title">
                    You have unsaved changes, are you sure you want to discard them?
                </h5>
            </DialogTitle>
            <DialogActions
                style={{
                    justifyContent: 'space-between',
                    padding: '0',
                }}
            >
                <Button
                    id="discard-changes-dialog-discard-button"
                    theme="danger"
                    onClick={() => {
                        onResolve();
                    }}
                    text="Discard changes"
                />
                <Button
                    id="discard-changes-dialog-cancel-button"
                    onClick={() => {
                        onReject();
                    }}
                    text="Cancel"
                />
            </DialogActions>
        </Dialog>
    );
}
